import {
  Component,
  OnInit,
  ViewChild,
  ElementRef,
  AfterViewInit,
  ViewEncapsulation,
  Inject,
  SecurityContext, isDevMode
} from '@angular/core';
import { MessagesModule } from 'primeng/messages';
import { ChangeDetectorRef } from '@angular/core';
import {
  interval
} from 'rxjs';


import {
  faCoffee,
  faLessThanEqual,
  faCopy,
  faExclamationTriangle,
  faFileUpload,
  faCloudUploadAlt,
  faTimes,
  faCheck,
  faEraser
} from '@fortawesome/free-solid-svg-icons';

import {
  KeycloakProfile
} from 'keycloak-js';
import {
  KeycloakService
} from 'keycloak-angular';
import {
  environment
} from '../../environments/environment';
import {
  THIS_EXPR
} from '@angular/compiler/src/output/output_ast';
import {
  SkipperService
} from '../services/skipper.service';
import {
  flatten,
  getHtmlTagDefinition
} from '@angular/compiler';
import { DomSanitizer } from '@angular/platform-browser';
//import * as jsPDF from 'jspdf';
import jspdf from 'jspdf';
import kjua from 'kjua';
import Resumable from 'resumablejs';
import { formatDate } from '@angular/common';


interface Tipo {
  name: String,
  code: String
}
interface Juzgado {
  name: String,
  code: String,
  descripcion: String
}

interface Vencimiento {
  name: String,
  code: number,
}

interface trayItem {
  date;
  size;
  fileName;
  shortId;
  fileType;

}


@Component({
  selector: 'app-upload',
  templateUrl: './upload.component.html',
  styleUrls: ['./upload.component.scss'],
  encapsulation: ViewEncapsulation.None
})




export class UploadComponent implements AfterViewInit, OnInit  {
  userDetails: KeycloakProfile;
  sessionToken = ''
  files = []
  faCoffee = faCoffee; faExclamationTriangle = faExclamationTriangle; faEraser = faEraser;
  faCopy = faCopy; faCheck = faCheck; faFileUpload = faFileUpload;
  faCloudUploadAlt = faCloudUploadAlt; faTimes = faTimes;
  showProgressBar = false;
  showUploadButton = true;
  barProgress = 0
  isFinished = false
  rateRelevancia = 0
  ModuleMessages = MessagesModule


  // isButtonDisabled = true;

  tipos: Tipo[] = []
  juzgados: Juzgado[] = []
  vencimiento: Vencimiento[] = []
  warnings = []
  selectedTipo: Tipo
  selectedJuzgado: Juzgado
  selectedVencimiento: Vencimiento = { name: "Sin plazo", code: -1 }
  numeroExpediente = '';
  descripcion = '';
  selectedCondicion: string;
  lastKBytes = 0;
  lastNow = new Date().getTime();
  speed = ''
  showBrowseFiles = true
  response_link = undefined
  val: number = 3;
  confirmCopied = false
  warns = []
  downloaderBaseUrl = environment.URL_DOWNLOADER
  downloaderBaseDDUrl = environment.BACK_DIRECT_DOWNLOAD
  final_report;
  all_verified = false
  hideIndividualQR = false
  group_id = ''
  group_prefix = ''
  juzgadosFilterDrop: Juzgado[] = []
  stay = true
  elementType = 'url';
  juzgadosLoading = false
  accepted_formats = environment.ACCEPTED_FILE_FORMATS
  video_formats = environment.VIDEO_FILE_FORMATS
  accepted_dd_formats = environment.ACCEPTED_DD_FILE_FORMATS
  html_report = ''
  userConfigMissing = false
  NO_META4_USER = environment.NO_META4_USER_MESSAGE




  r = new Resumable({
    target: 'http://192.168.68.27:8089/resumable_upload',
    query: {
      upload_token: 'my_token'
    }
  });

  @ViewChild('input') input: ElementRef;
  @ViewChild('bar') bar: ElementRef;
  // @ViewChild('ourForm', {static: true}) ourForm ;
  ngAfterViewInit() {
    if (isDevMode()) console.log(this.input.nativeElement.innerHTML);
  }

  constructor(private keycloakService: KeycloakService,
    private skipperService: SkipperService,
    private changeDetection: ChangeDetectorRef,
    private sanitizer: DomSanitizer
  ) { }

  async doLogout() {
    await this.keycloakService.logout();
  }

async ngDoCheck(){
  1
}

  async ngOnInit() {
  
    if (await this.keycloakService.isLoggedIn()) {
      if (isDevMode()) console.log("logged in!!");
      this.userDetails = await this.keycloakService.loadUserProfile();
      if (isDevMode()) console.log(this.userDetails['username'])
      this.sessionToken = await this.keycloakService.getToken();

      this.skipperService.getUsuarios().subscribe(r => {
        if (r['error_code'] != undefined && r['error_code'] == 'err-06') {
          this.userConfigMissing = true

        }
      })
    }
    localStorage.setItem("isFinished", "false")


    // cargando tipos de actos

    this.juzgadosLoading = true
    this.skipperService.getJuzgados().subscribe(r => {
      let tarr = []
      for (let a = 0; a < r['data'].length; a++) {
        tarr.push({ "name": r['data'][a]['cod_nomenclador'] + '-' + r['data'][a]['descripcion'], "code": r['data'][a]['id'], "cod_nomenclador": r['data'][a]['cod_nomenclador'], "descripcion": r['data'][a]['descripcion'] });
      }
      this.juzgadosLoading = false
      this.juzgados = tarr
    })
    this.vencimiento = [
      { name: "Sin plazo", code: -1 },
      { name: "  7 días (una semana)", code: 7 },
      { name: " 30 días (un mes)", code: 30 },
      { name: " 60 días (dos meses)", code: 60 },
      { name: "365 días (un año)", code: 365 },
      { name: "730 días (dos años)", code: 730 }
    ]


    // cargando juzgados

    this.skipperService.getTiposActos().subscribe(r => {
      let tarr = []
      for (let a = 0; a < r['data'].length; a++) {
        tarr.push({ "name": r['data'][a]['descripcion'], "code": r['data'][a]['id'], "cod_nomenclador": r['data'][a]['cod_nomenclador'] });
      }
      this.tipos = tarr
    })

    interval(5000).subscribe(() => {
      var now = new Date().getTime();
      var bytes = parseInt(localStorage.getItem('progress')) || 0;
      var total = parseInt(localStorage.getItem('total')) || 1;
      var percent = bytes / total * 100;
    
      let temp_isfinished = localStorage.getItem("isFinished");
      if (temp_isfinished == 'true') {
        this.isFinished = true;
      }
    
      // Mantener un valor decimal preciso, redondear solo al representar visualmente
      this.barProgress = percent;
    
      this.speed = "Subiendo a la nube - Esperar reporte";
     
      // something
    });
    
  }
  updateSelectedCondicion() {
    if (!this.warnings.includes('ext_dd_not_allowed')) {
      this.selectedCondicion = '';
    }
  }
  clearAll() {
    this.stay = true;
    this.files = []
    this.numeroExpediente = ''
    this.descripcion = ''
    this.val = 1
    this.selectedCondicion = ''
    this.selectedTipo = undefined
    this.selectedJuzgado = undefined
    this.selectedVencimiento = { name: "Sin plazo", code: -1 }
    this.showBrowseFiles = true
    localStorage.setItem('isFinished', 'false')
    this.isFinished = false
    this.showProgressBar = false
    if (isDevMode()) console.log("//");
    if (isDevMode()) console.log(this.showProgressBar && this.isFinished);
  }

  // searchJuzgadosDrop(query) {
  //   // this.juzgadosFilterDrop=this.juzgados
  //   if (isDevMode()) console.log(query);
  //   let q = query.query
  //   let temp = this.juzgados.filter(function (obj) {
  //     return obj['name'].toLowerCase().includes(q.toLowerCase());
  //   });
  //   this.juzgadosFilterDrop = [...temp]
  //   if (isDevMode()) console.log(this.juzgadosFilterDrop)
  // }

  validateFileFormat() {


    // console.log("validating file format ON REMOVE")
    // console.log(this.files)
    // let has_video = false
    // this.files.map(f=>
    //   {
    //     let extensionArr = f.name.split('.')
    //     let f_extension = extensionArr[extensionArr.length - 1].toLowerCase()



    //      if (this.video_formats.includes(f_extension.trim())) {
    //       has_video = true
    //     } 

    //     //   f['valid'] = true
    //     // } else {
    //     //   f['valid'] = false
         
    //   })

    // if (!has_video) {
    //   this.warnings = []
    //   return
    // }

  }

  

  inputUpdated(evt) {

    if (isDevMode()) console.log("updated!!");
    if (isDevMode()) console.log(evt);
    if (isDevMode()) console.log(evt.target.files)
   
    let temp_arr = [...evt.target.files]
  
    if (temp_arr.length > 0) {
      this.input.nativeElement.value = ''
      this.showBrowseFiles = false
      //clean green finished bar
      this.showProgressBar = false
      this.isFinished = false
    }
    let bigSizeWarning = false
    for (let index = 0; index < temp_arr.length; index++) {
      
      if(temp_arr[index].size>200000000 && bigSizeWarning==false){ //over 200MB will show a message 
      //  alert("Ha seleccionado algun archivo de gran tamano esto tiene una demora en la subida, por favor no cierre la ventana y espere el codigo QR ")
       temp_arr[index]['bigSizeWarning']=true
       temp_arr[index]['estimatedUploadTime'] = Math.round(temp_arr[index].size / 1000000 / (256 / 18)) * 18; // 18 minutes for 256 MB
       bigSizeWarning = true

      }
      
      temp_arr[index]['formatted_name'] = this.cutAndPrepare(temp_arr[index].name);
      
    }

    this.files = temp_arr
  }



  copy2Clipboard(target) {
    if (isDevMode()) console.log(target)
    let nombre_archivo = target['metadata']['archivo']['nombre']
    let descripcionTipoActo = "\n" + target['metadata']['descripcion_tipo_acto']
    let numeroExpediente = "\n" + target['metadata']['numero_expediente']
    let relevancia = "\n" + target['metadata']['relevancia']
    let short_id = "\n" + target['metadata']['short_id']
    let short_id_group = "\n" + target['metadata']['short_id_group']
    let fecha_subida = "\n" + target['metadata']['archivo']['upload_start']
    let url = "\n" + this.getFileLink(target['metadata']['condicion'], target['metadata']['short_id'])
    let fullBody = "Archivo:" + "\n" + nombre_archivo + "\n" + "Identificador: " + short_id + "\n" + "Identificador de Grupo: " + short_id_group + "\n" + "Tipo de Acto:" + descripcionTipoActo + "\n" + "Expediente / Legajo: " + numeroExpediente + "\n" + "Fecha de presentación:" + fecha_subida + "\n" + " Relevancia: " + relevancia + "\n" + " LINK=" + url
    var textArea = document.createElement("textarea");
    let descripcion = target['metadata']['descripcion']
    textArea.value = fullBody;

    // Avoid scrolling to bottom
    textArea.style.top = "0";
    textArea.style.left = "0";
    textArea.style.position = "fixed";

    document.body.appendChild(textArea);
    textArea.focus();
    textArea.select();

    try {
      var successful = document.execCommand('copy');
      this.confirmCopied = successful;
      //this.confirmCopied=true

    } catch (err) {
      console.error('Fallback: Oops, unable to copy', err);
    }

    document.body.removeChild(textArea);


  }
  sanitize(params) {
    //  if(isDevMode()) console.log("sanitize")
    // if(isDevMode()) console.log(params['metadata']['short_id'])
    if (isDevMode()) console.log("sanitized value is");
    if (isDevMode()) console.log(this.getFileLink(params['metadata']['condicion'], params['metadata']['short_id']));


    return this.getFileLink(params['metadata']['condicion'], params['metadata']['short_id'])



  }

  getFileLink(condicion, shortID) {
    if (condicion == 'publico-descarga-directa') {
      // if(isDevMode()) console.log( (this.sanitizer.bypassSecurityTrustUrl(this.downloaderBaseDDUrl+shortID)));

      return this.sanitizer.sanitize(SecurityContext.HTML, this.sanitizer.bypassSecurityTrustHtml(this.downloaderBaseDDUrl + shortID));
      //return this.sanitizer.bypassSecurityTrustHtml(this.downloaderBaseDDUrl+shortID);
    }
    if (condicion !== 'publico-descarga-directa') {
      return this.sanitizer.sanitize(SecurityContext.HTML, this.sanitizer.bypassSecurityTrustHtml(this.downloaderBaseUrl + shortID));
      // return this.sanitizer.bypassSecurityTrustUrl(this.downloaderBaseUrl+shortID);
    }
  }

  formatShortDate(d) {
    let temp_date = new Date(d)
    let day = temp_date.getDate()
    let month = temp_date.getMonth() + 1
    let year = temp_date.getFullYear()
    let hour = temp_date.getHours()
    let minute = temp_date.getMinutes()
    let strminute = ''
    if (minute < 10) {
      strminute = "0" + minute.toString()
    } else { strminute = minute.toString() }
    return day + "/" + month + "/" + year + " a las " + hour + ":" + strminute
  }


  generate_report(files) {
    if (isDevMode()) console.log("generating report")



    /* 
       doc.html(document.body, {
         callback: function (doc) {
           doc.save();
         },
         x: 10,
         y: 10
      });
    */

    let qr
    let textContent
    this.final_report = new jspdf({
      orientation: "portrait",
      unit: "mm",
      format: [210, 297]
    });

    let newLine = '\n'
    let leftMargin = 10
    let qrPos = 32 + 55
    let separator = 80 + 55
    let nombreArchivoPos = 40 + 55
    let fechaPresentacion = 45 + 55
    let tamanioArchivoPos = 50 + 55
    let numeroExpedientePos = 60 + 55
    let url_text = 55 + 55



    for (let aa = 0; aa < files.length; aa++) {


      const element = files[aa];
      let qr_group = undefined
      let url = this.getFileLink(element['metadata']['condicion'], element['metadata']['short_id'])
      let url_group = this.getFileLink(element['metadata']['condicion'], element['metadata']['short_id_group'])
      qr = kjua({ text: url, render: 'image' });

      if (aa == 0) {
        qr_group = kjua({ text: url_group, render: 'image' });

        this.final_report.setFontSize(12);
        this.final_report.setFont("times");
        this.final_report.text('Poder Judicial de Mendoza', 75, 12);
        this.final_report.setFontSize(10); 18
        this.final_report.setFont("times");
        this.final_report.text('Informe de Presentación de Documentos', 10, 18);
        
        
        this.final_report.setFont("times");
        this.final_report.setFontSize(10);
        this.final_report.text('Usuario presentante: ' + element['metadata']['id_usuario'], 10, 35);
        
        
        
        
        this.final_report.text('Juzgado / Oficina: ' + element['metadata']['descripcion_juzgado'], 10, 40);
        this.final_report.text('N° Expediente / Legajo: ' + element['metadata']['numero_expediente'], 10, 45);
        this.final_report.text('Visibilidad: ' + element['metadata']['condicion'], 10, 50);
        this.final_report.text('Relevancia: ' + element['metadata']['relevancia'], 10, 55);
        this.final_report.text('Descripcion: ' + this.formatTextReport(element['metadata']['descripcion']), 10, 60);

        if (element['metadata']['condicion'] !== 'publico-descarga-directa') this.final_report.text('URL de Grupo= ' + url_group, 10, 70);
        this.final_report.line(5, 80, 205, 80, 'S')
        this.final_report.text(190, 289, "Pag." + this.final_report.internal.getCurrentPageInfo().pageNumber);
        if (element['metadata']['condicion'] !== 'publico-descarga-directa') this.final_report.addImage(qr_group, 'PNG', 140, 30, 30, 30)
      }


      this.final_report.setFontSize(10);
      this.final_report.setFont("times");
      this.final_report.text(this.formatTextReport(element['metadata']['archivo']['nombre']), leftMargin, nombreArchivoPos);
      this.final_report.text('Fecha de presentación: ' + this.formatShortDate(element['metadata']['archivo']['upload_start']), leftMargin, fechaPresentacion);
      this.final_report.text('Tamaño del Archivo: ' + Math.trunc(element['metadata']['archivo']['size'] / 1000) + ' KBytes', leftMargin, tamanioArchivoPos);
      this.final_report.text('URL Individual: ' + url, leftMargin, url_text);


      this.final_report.addImage(qr, 'PNG', 140, qrPos, 30, 30)
      this.final_report.line(5, separator, 205, separator, 'S')
      if ((separator > (297 - 97)) || (qrPos > (297 - 97))) {
        //the current page wont fit another iteration. adding a new page
        this.final_report.addPage()
        this.final_report.text(190, 289, "Pag." + this.final_report.internal.getCurrentPageInfo().pageNumber);
        // leftMargin=20
        qrPos = 10 + 45
        separator = 0 + 45
        nombreArchivoPos = 10 + 45
        tamanioArchivoPos = 15 + 45
        fechaPresentacion = 20 + 45
        url_text = 25 + 45
        //let usuarioPos=50+45
        numeroExpedientePos = 50 + 45
      } else {
        
        qrPos = qrPos + 50
        separator = separator + 51
        nombreArchivoPos = nombreArchivoPos + 54
        tamanioArchivoPos = tamanioArchivoPos + 54
        fechaPresentacion = fechaPresentacion + 54
        url_text = url_text + 54
        //usuarioPos=usuarioPos+80
        numeroExpedientePos = numeroExpedientePos + 55
      }


    }




    // doc.text('This is client-side Javascript, pumping out a PDF.',20, 30);
    // doc.addPage();
    // doc.text('Do you like that?',20, 20);

  }


  formatTextReport(str) {
    var result = '';
    while (str.length > 0) {
      result += str.substring(0, 45) + '\n';
      str = str.substring(45);
    }
    return result;
  }




  download_report() {
    this.final_report.save('reporte.pdf')


  }




  //  dragOverHandler(ev) {
  //      if(isDevMode()) console.log('File(s) in drop zone');

  //     // Prevent default behavior (Prevent file from being opened)
  //     ev.preventDefault();
  //   }


  //   dropHandler(ev) {
  //      if(isDevMode()) console.log('File(s) dropped');

  //     // Prevent default behavior (Prevent file from being opened)
  //     ev.preventDefault();

  //     if (ev.dataTransfer.items) {
  //       // Use DataTransferItemList interface to access the file(s)
  //       for (var i = 0; i < ev.dataTransfer.items.length; i++) {
  //         // If dropped items aren't files, reject them
  //         if (ev.dataTransfer.items[i].kind === 'file') {
  //           var file = ev.dataTransfer.items[i].getAsFile();
  //            if(isDevMode()) console.log('... file[' + i + '].name = ' + file.name);
  //         }
  //       }
  //     } else {
  //       // Use DataTransfer interface to access the file(s)
  //       for (var i = 0; i < ev.dataTransfer.files.length; i++) {
  //          if(isDevMode()) console.log('... file[' + i + '].name = ' + ev.dataTransfer.files[i].name);
  //       }
  //     }
  //   }





  validateFieldsBeforeUpload() {
    this.warnings = []
    let missings = []

    if (this.selectedCondicion == undefined) {
      missings.push('condicion');
    }

    if (this.selectedTipo == undefined) {
      missings.push('tipo');
    }
    if (!this.juzgados.includes(this.selectedJuzgado)) {
      missings.push('juzgado')
    }
    //if(this.numeroExpediente=='' || this.numeroExpediente.length<2) missings.push('expediente');

    if (this.files.length < 1) {
      missings.push('files');
    } else {
      let f_extension
      let flag_ext_error = false
      let flag_dd_allowed = true
      for (let a = 0; a < this.files.length; a++) {
        // if(isDevMode()) console.log(this.files[a])
        let temp_arr = this.files[a]['name'].split('.')
        f_extension = temp_arr[temp_arr.length - 1].toLowerCase()
        // if(isDevMode()) console.log("uploaded file extension is",f_extension)
        // if(isDevMode()) console.log(this.accepted_formats)
        if (f_extension == undefined) {
          // if(isDevMode()) console.log("f_extension is undefined")
          missings.push('ext_not_allowed');
        }

        let flag_ext_error = false
        if (this.video_formats.includes(f_extension.trim())) {
          flag_dd_allowed = false
        }

        if (this.selectedCondicion !== 'publico-descarga-directa' && !this.accepted_formats.includes(f_extension.trim())) {
          // if(isDevMode()) console.log("NOT ACCEPTED"+f_extension)
          flag_ext_error = true
          missings.push('ext_not_allowed');
          break;
        }
        if (this.selectedCondicion == 'publico-descarga-directa' && !this.accepted_dd_formats.includes(f_extension.trim())) {
          // if(isDevMode()) console.log("NOT ACCEPTED"+f_extension)
          flag_ext_error = true
          missings.push('ext_dd_not_allowed');
          break;
        }

      }





      /*  if(flag_ext_error){

          if(isDevMode()) console.log("file rejected")
        missings.push('ext_not_allowed');
         } */
    }

    if (missings != []) this.warnings = missings;


    return missings.length == 0
  }








  


showDownloadButton: boolean = false;



upload() {

  this.warnings.map(w=>{
    console.log("warning")
    console.log(w)
    if(w=='ext_dd_not_allowed') {this.selectedCondicion='privado';return}
  })


  if (this.validateFieldsBeforeUpload()) {
    this.lastKBytes = 0;
    this.lastNow = new Date().getTime();
    this.showUploadButton = false;
    this.showProgressBar = true;
    var formData = new FormData();
    this.group_id = ''
    this.group_prefix = ''
    var vence = true
    if (this.selectedVencimiento.code === -1) {
      vence = false
    }

    let metaObj = {
      "id_tipo_acto": this.selectedTipo.code,
      "id_juzgado": this.selectedJuzgado.code,
      "descripcion_juzgado": this.selectedJuzgado.descripcion,
      "numero_expediente": this.numeroExpediente,
      "relevancia": this.val,
      "condicion": this.selectedCondicion,
      "descripcion": this.descripcion,
      "descripcion_tipo_acto": this.selectedTipo.name,
      "cantidad_dias": this.selectedVencimiento.code,
      "vencimiento": vence
    }

    let options = {
      header: {
        'Bearer ': this.sessionToken
      }
    };

    formData.append("tenant", "cpl");
    //formData.append("url_for_validate", "localhost:2343"); // number 123456 is immediately converted to a string "123456"
    formData.append("metadata", JSON.stringify(metaObj))
    // HTML file input, chosen by user
    //formData.append("file", this.files[0]);

    for (let index = 0; index < this.files.length; index++) {
      formData.append("file", this.files[index])
    }


    // var request = new XMLHttpRequest();
    // request.onreadystatechange = function() {
    //   if (request.readyState == XMLHttpRequest.DONE) {
    //    // resolve(request.responseText)
    //       alert(JSON.stringify(request.responseText));

    //   }
    // }

    //request.open("POST", environment.BACK_INITIAL);
    //request.send(formData);

    // use our custom AJAX function
    this.uploadAsync(environment.BACK_INITIAL, 'POST', formData, this.sessionToken).then(data => {
      // if(isDevMode()) console.log(data)
      this.response_link = data['response']
      // if(isDevMode()) console.log(this.response_link)
      for (let a = 0; a < this.response_link.length; a++) {
        if (a == 0) {
          this.group_id = this.response_link[a]['metadata']['short_id_group'];
          this.group_prefix = this.response_link[a]['metadata']['prefix']
        }
        this.response_link[a]['verified'] = false;

      }
      this.verifyUploadedStuff()
    }

    );



  } else {
    //some toast here
  }
}

uploadAsync = (url, method, data, token) => {
  return new Promise(function (resolve, reject) {
    let request = new XMLHttpRequest();

    request.responseType = 'json';

    request.upload.onprogress = function (e) {
      // if(isDevMode()) console.log("PROGRESS")
      localStorage.setItem('progress', e.loaded.toString())
      localStorage.setItem('total', e.total.toString())
      // if(isDevMode()) console.log(e.loaded);
      // if(isDevMode()) console.log(e.total);


    }
    request.onreadystatechange = function () {
      if (request.readyState === XMLHttpRequest.DONE) {
        if (request.status === 200) {
          resolve(request.response);

        } else {
          reject("Error(request.status)");
        }
      }
    };


    request.onerror = function () {
      reject(Error("Network Error"));
    };


    request.open(method, url, true);
    request.setRequestHeader('Authorization', 'Bearer ' + token)
    request.send(data);


    request.addEventListener("loadend", function () {
      localStorage.setItem("isFinished", "true")
    });
  });
}


loadEnd() {
  //this.isFinished=true
  localStorage.setItem("isFinished", "true")
  //alert(this.isFinished);

}

updateProgress() {

}




sleep(ms) {
  return new Promise(resolve => setTimeout(resolve, ms));
}

  async verifyUploadedStuff() {
  await this.sleep(1000);
  let deadline_counter = 0;


  while (this.stay) {

    deadline_counter++

    if (isDevMode()) console.log("deadline counter=" + deadline_counter)
    this.all_verified = true
    for (let bb = 0; bb < this.response_link.length; bb++) {

      if (!this.response_link[bb]['verified']) { this.all_verified = false }

    }
    if (this.all_verified) {
      //all verified! 
      //proceeding to assemble pdf report
      this.generate_report(this.response_link)
      // if(isDevMode()) console.log("breaking from all verified")
      this.stay = false

    }

    for (let a = 0; a < this.response_link.length; a++) {

      if (!this.response_link[a]['verified']) {

        this.skipperService.verify(this.response_link[a]['metadata']['short_id']).subscribe(r => {
          this.stay = true
          // if(isDevMode()) console.log("response of consulta is");
          // if(isDevMode()) console.log(r);
          
          if ('error_code' in r) {
            // if(isDevMode()) console.log("NOT VERIFIED YET FROM BACK");

          } else {
            //   if(isDevMode()) console.log("WTHHHH");
            // if(isDevMode()) console.log(r['data']['documento']['short_id']);
            // if(isDevMode()) console.log(this.response_link[a]['metadata']['short_id']);

            if (r['data']['documento']['short_id'] == this.response_link[a]['short_id']) {
              this.response_link[a]['verified'] = true
              this.changeDetection.detectChanges();
              // if(isDevMode()) console.log("document is verified");        
            } else { this.stay = false }
          }

        });
      }
      await this.sleep(1000);

    }
    if (deadline_counter > 5) { if (isDevMode()) console.log("setting stay false"); this.stay = false }
  }
}

removeFile(file) {
  
   this.validateFileFormat()
    //if user removes all selected files, then showing browse files again and cleaning JIC
  let target = this.files.indexOf(file)
  //     if(isDevMode()) console.log(target)

  this.files.splice(target, 1)
  if (this.files.length < 1) {
    this.showBrowseFiles = true
    this.input.nativeElement.value = ''
  }
}



cutAndPrepare(fln) {
  let processed = ''
  let rest = ''
  let processed0 = ''
  let rest0 = ''
  let tail = ''
  let triple_dots = ''
  if (fln.length > 18) {
    processed = fln.slice(0, 18)
    rest = fln.slice(18, fln.length)
    if (rest.length > 18) {
      processed0 = rest.slice(0, 18)
      rest0 = rest.slice(18, rest.length)
    } else {
      rest0 = rest
    }
  } else {
    processed = fln
  }
  let dot_suspect = fln.slice(fln.length - 4, fln.length - 3)
  if (dot_suspect == '.') {
    if (rest0.length > 18) {
      tail = fln.slice(fln.length - 3, fln.length)
    }
  }
  if ((processed + ' ' + processed0 + ' ' + rest0).length > 54) triple_dots = '...'
  return ((processed + ' ' + processed0 + ' ' + rest0).slice(0, 54) + triple_dots + tail)
}
closeSession() {

  this.skipperService.closeSession()
}

resumableUploader(method) {
  if (method == "upload") {
    this.r.upload()
  }

  if (method == "pause") {
    this.r.pause()
  }






}



  // isButtonDisabled: boolean = false;
  // checkButtonDisabledStatus() {
  //   if (this.selectedCondicion === 'publico-descarga-directa' && !this.accepted_formats.includes(f_extension.trim())) {
  //     this.isButtonDisabled = true; // Deshabilita el botón si se cumple la condición
  //   } else {
  //     this.isButtonDisabled = false; // Habilita el botón si no se cumple la condición
  //   }
  // }


}



